import Vuex from 'vuex';

const store = new Vuex.Store({
    state: {
        activeLocale: null,
        loading: false,
        loadingMessage: null,
    },
    mutations: {
        setLoading (state, loading) {
            // only set loading state to false if there are no more request running
            if(!loading) {
                if(Vue.prototype.$Api.getRequestsInProcces() == 0 ) {
                    state.loading = loading;
                }
            } else {
                state.loading = loading;
            }

            if(! loading) {
                state.loadingMessage = null;
            }
        },
        setLoadingMessage (state, loadingMessage) {
            state.loadingMessage = loadingMessage;
        },
        setActiveLocale (state, locale) {
            state.activeLocale = locale;
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store.js